import { Outlet } from 'react-router-dom';
import Header from './Header';
import Footer from './Footer';
import { BaseComponentProps } from '@/types';

interface LayoutProps extends BaseComponentProps {}

export default function Layout({ className = '', children }: LayoutProps) {
  return (
    <div className={`page-layout ${className}`}>
      <a
        href="#main-content"
        className="sr-only focus:not-sr-only focus:absolute focus:left-4 focus:top-4 focus:z-50 focus:rounded-lg focus:bg-white focus:px-4 focus:py-2 focus:text-sm focus:font-semibold focus:text-slate-900 focus:shadow"
      >
        Skip to content
      </a>
      <Header />
      <main id="main-content" className="flex-1">
        <div className="content-layout">
          {children || <Outlet />}
        </div>
      </main>
      <Footer />
    </div>
  );
}
